import React from 'react';

import { CUSTOMER_ADVANCED_SETTINGS_ALL_PAGE_KEYS } from '@lumapps/customer-settings/constants';
import { CUSTOMER_ADVANCED_SETTINGS_PAGE_ID } from '@lumapps/customer/constants';
import { customerAdvancedSettingsRoute } from '@lumapps/customer/routes';
import { LOGIN_HELP } from '@lumapps/login-help/keys';
import { signInPageRoute } from '@lumapps/login-help/routes';
import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiSettings } from '@lumapps/lumx/icons';
import { isCheckInEnabled } from '@lumapps/mobile-login/ducks/selectors';
import { mobileSelfRegistrationRoute } from '@lumapps/mobile-login/routes';
import { useSelector } from '@lumapps/redux/react';
import { termsAndConditionsRoute } from '@lumapps/terms-and-conditions-admin/routes';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { CUSTOMER_BACK_OFFICE } from '../../keys';

export interface CustomerSettingsSideNavigationProps extends Partial<SideNavigationItemProps> {
    /** whether the user is allowed to view the side navigation or not */
    isAllowed: boolean;
}

export const CustomerSettingsSideNavigation = (props: Partial<CustomerSettingsSideNavigationProps>) => {
    const { isAllowed, ...restOfProps } = props;

    const { translateKey } = useTranslate();

    const isCheckInFeatureEnabled = useSelector(isCheckInEnabled);

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            id="platform-settings"
            label={translateKey(CUSTOMER_BACK_OFFICE.CUSTOMER_SETTINGS)}
            icon={mdiSettings}
        >
            <SideNavigationItem
                label={translateKey(GLOBAL.ADVANCED_SETTINGS)}
                route={customerAdvancedSettingsRoute}
                id={CUSTOMER_ADVANCED_SETTINGS_PAGE_ID}
                pageKeys={CUSTOMER_ADVANCED_SETTINGS_ALL_PAGE_KEYS}
            />

            <SideNavigationItem label={translateKey(GLOBAL.TERMS_AND_CONDITIONS)} route={termsAndConditionsRoute} />
            <SideNavigationItem label={translateKey(LOGIN_HELP.SIGN_IN_PAGE)} route={signInPageRoute} />
            {isCheckInFeatureEnabled && (
                <SideNavigationItem
                    label={translateKey(GLOBAL.SELF_REGISTRATION_TITLE)}
                    route={mobileSelfRegistrationRoute}
                />
            )}
        </SideNavigationItem>
    );
};

CustomerSettingsSideNavigation.displayName = 'SideNavigationItem';
